var src,
srcset,
SlowVideo,
opt_windowWidth,
opt_windowHeight,
critical2,
cls_css,
lazyBackground,
lazyIframe,
lazybg,
s,
i,
flag = 1,
external_single_loaded = 1;
function opt_init() {
(cls_css = document.querySelectorAll(".cls_css")).forEach(function (t) {
t.remove();
}),
lazyLoadCss(),
SlowLoadVideo(),
lazyLoadStyle(),
lazyLoadImg(),
lazyLoadBackground(),
lazyLoadIframe(),
lazyLoadPoster(),
flag && ((flag = 0), load_all_js());
}
function insertAfter(t, e) {
e.parentNode.insertBefore(t, e.nextSibling);
}
function lazyLoadImg() {
var t = document.querySelectorAll("img.lazy2");
for (i = 0; i < t.length; i++)
(src = opt_windowWidth < 600 ? (t[i].dataset.mobsrc === void 0 ? t[i].dataset.src : t[i].dataset.mobsrc) : (t[i].dataset.src === void 0 ? t[i] : t[i].dataset).src),
(srcset = t[i].getAttribute("data-srcset") ? t[i].getAttribute("data-srcset") : ""),
src != null && src != "" && (t[i].src = src),
srcset != null && srcset != "" && (t[i].srcset = srcset),
t[i].classList.remove("lazy2");
}
function lazyLoadImg2() {
var t = document.querySelectorAll("img.lazy3");
for (i = 0; i < t.length; i++) {
var e = t[i].getBoundingClientRect();
e.top != 0 &&
e.top - opt_windowHeight < 1 &&
((src = opt_windowWidth < 600 ? (t[i].dataset.mobsrc === void 0 ? t[i].dataset.src : t[i].dataset.mobsrc) : (t[i].dataset.src === void 0 ? t[i] : t[i].dataset).src),
(srcset = t[i].getAttribute("data-srcset") ? t[i].getAttribute("data-srcset") : ""),
src != null && src != "" && (t[i].src = src),
srcset != null && srcset != "" && (t[i].srcset = srcset),
t[i].classList.remove("lazy3"));
}
}
function lazyLoadBackground() {
(lazyBackground = document.querySelectorAll(".lazybg")).forEach(function (t) {
(lazybg = opt_windowWidth < 600 ? (t.dataset.mobstyle === void 0 ? t.dataset.style : t.dataset.mobstyle) : (t.dataset.style === void 0 ? t : t.dataset).style) != null && lazybg != "" && (t.style = lazybg),
t.classList.remove("lazybg");
});
}
function SlowLoadVideo()  {
(lazyVideo = document.querySelectorAll("video")).forEach(function (t) {
t.dataset.src != null && t.dataset.src != "" && ((t.src = t.dataset.src), delete t.dataset.src);
});
}
function lazyLoadBackground2() {
(lazyBackground = document.querySelectorAll(".lazybg")).forEach(function (t) {
var e = t.getBoundingClientRect();
e.top != 0 &&
e.top - opt_windowHeight < 100 &&
((lazybg = opt_windowWidth < 600 ? (t.dataset.mobstyle === void 0 ? t.dataset.style : t.dataset.mobstyle) : (t.dataset.style === void 0 ? t : t.dataset).style) != null && lazybg != "" && (t.style = lazybg),
t.classList.remove("lazybg"));
});
}
function lazyLoadCss() {
var t = document.querySelectorAll("link[data-href]");
for (i = 0; i < t.length; i++) {
var e = document.createElement("link");
(e.href = t[i].getAttribute("data-href")), (e.rel = "stylesheet"), t[i].parentNode.insertBefore(e, t[i]), delete t[i].dataset.href, t[i].parentNode.removeChild(t[i]);
}
}
function lazyLoadStyle() {
var t = document.querySelectorAll("style[type=lazyload2]");
for (i = 0; i < t.length; i++) {
var e = document.createElement("style");
(e.innerHTML = t[i].innerHTML), t[i].parentNode.insertBefore(e, t[i]), t[i].parentNode.removeChild(t[i]);
}
}
function lazyLoadIframe() {
(lazyIframe = document.querySelectorAll("iframe")).forEach(function (t) {
t.dataset.src != null && t.dataset.src != "" && ((t.src = t.dataset.src), delete t.dataset.src);
});
}
function lazyLoadPoster() {
(lazyPoster = document.querySelectorAll("video[data-poster]")),
lazyPoster.forEach(function (t) {
t.dataset.poster != null && t.dataset.poster != "" && ((t.poster = t.dataset.poster), delete t.dataset.poster);
});
}
function w3_load_js_uri(t) {
var e = document.createElement("script");
if (t.attributes !== void 0) for (var o, a = 0, n = t.attributes, i2 = n.length; a < i2; a++) (o = n[a]).nodeName != "data-src" && o.nodeName != "type" && e.setAttribute(o.nodeName, o.nodeValue);
return (e.src = t.getAttribute("data-src")), insertAfter(e, t), delete t.dataset.src, delete t.type, t.parentNode.removeChild(t), e;
}
function w3_load_inline_js_single(t) {
if (!external_single_loaded)
return (
setTimeout(function () {
w3_load_inline_js_single(t);
}, 200),
!1
);
s = document.createElement("script");
for (var e = 0; e < t.attributes.length; e++) {
var o = t.attributes[e];
o.name != "type" && s.setAttribute(o.name, o.value);
}
(s.innerHTML = t.innerHTML), insertAfter(s, t), t.parentNode.removeChild(t);
}
function lazyLoadScripts() {
var t,
e = document.querySelectorAll("script[type=slowloadscript]");
if (e.length < 1) return document.body.classList.add("opt_loaded"), void fullJSLoadedCB();
e[0].getAttribute("data-src") !== null
? (((t = w3_load_js_uri(e[0])).onload = function () {
lazyLoadScripts();
}),
(t.onerror = function () {
lazyLoadScripts();
}))
: (w3_load_inline_js_single(e[0]), lazyLoadScripts());
}
function optAnalytics() {
document.querySelectorAll(".analytics").forEach(function (t) {
(trekkie.integrations = !1), ((s = document.createElement("script")).innerHTML = t.innerHTML), insertAfter(s, t), t.parentNode.removeChild(t);
});
}
function optBoomerang() {
document.querySelectorAll(".boomerang").forEach(function (t) {
(window.BOOMR.version = !1), ((s = document.createElement("script")).innerHTML = t.innerHTML), insertAfter(s, t), t.parentNode.removeChild(t);
});
}
function load_all_js() {
Shopify.designMode || -1 < window.location.href.indexOf("/cart") || -1 < window.location.href.indexOf("/checkout")
? console.log("No-optimization")
: (console.log("Yes-optimization"),
setTimeout(function () {
var t = document.createEvent("Event");
t.initEvent("opt_load", !0, !0), window.document.dispatchEvent(t);
}, 500),
setTimeout(function () {
var t = document.createEvent("Event");
t.initEvent("DOMContentLoaded2", !0, !0), window.document.dispatchEvent(t);
}, 5e3)),
lazyLoadScripts(),
setTimeout(function () {
(critical2 = document.querySelectorAll(".critical2")).forEach(function (t) {
t.remove();
});
}, 9999),
setInterval(function () {
lazyLoadImg(), lazyLoadIframe();
});
}
function fullJSLoadedCB() {
setTimeout(function () {});
}
document.addEventListener("DOMContentLoaded", function () {
(opt_windowWidth = screen.width),
(opt_windowHeight = screen.height),
(SlowVideo = document.querySelectorAll("video")),
(SlowIframe = document.querySelectorAll("iframe")),
lazyLoadImg2(),
lazyLoadBackground2(),
window.addEventListener("scroll", function () {
opt_init();
}),
window.addEventListener("mousemove", function () {
opt_init();
}),
window.addEventListener("touchstart", function () {
opt_init();
});
});